import axios from 'axios';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ItemContextProvider from 'components/shared/context/ItemContextProvider';
import ItemsContextProvider from 'components/shared/context/ItemsContextProvider';
import ModalContextProvider from 'components/shared/context/ModalContextProvider';
import ToastContextProvider from 'components/shared/context/ToastContextProvider';
import UserContextProvider from 'components/shared/context/UserContextProvider';

import BuyerLandingPage from 'pages/BuyerLandingPage';
import ErrorPage from 'pages/ErrorPage';
import HomePage from 'pages/HomePage';
import ItemPage from 'pages/ItemPage';
import SellerLandingPage from 'pages/SellerLandingPage';
import SignInPage from 'pages/SignInPage';
import SignUpPage from 'pages/SignUpPage';

const App: React.FC = () => {
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND;

  return (
    <UserContextProvider>
      <ItemsContextProvider>
        <ItemContextProvider>
          <ToastContextProvider>
            <ModalContextProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/item/:itemId" element={<ItemPage />} />
                  <Route path="/landing/buyer" element={<BuyerLandingPage />} />
                  <Route
                    path="/landing/seller"
                    element={<SellerLandingPage />}
                  />
                  <Route path="/sign-in" element={<SignInPage />} />
                  <Route path="/sign-up" element={<SignUpPage />} />
                  <Route path="*" element={<ErrorPage />} />
                </Routes>
              </BrowserRouter>
            </ModalContextProvider>
          </ToastContextProvider>
        </ItemContextProvider>
      </ItemsContextProvider>
    </UserContextProvider>
  );
};

export default App;
